/**
 * Replacement to remove lodash dependency
 * https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_debounce
 */
export function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

/**
 * Replacement to remove lodash dependency
 * https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_isundefined
 */
export function isUndefined(value) {
  return value === undefined;
}
